<!-- MallSortTable -->

<template>
  <div class="sort-table-page">
    <van-popup v-model="visibleFilterFlag" :style="{ height: '50%' }" position="bottom" round>
      <div class="filter">
        <div class="title">品牌</div>
        <div style="padding: 8px;">
          <van-tag v-for="brand in brands" :key="brand.brandId" :class="[brand.active ? 'tag-active' : 'tag']"
            size="medium" @click="tagClick($event, brand.brandId)">{{ brand.name }}
          </van-tag>
        </div>

        <span class="title">价格区间</span>
        <div style="display: flex;margin-top: 8px;font-size: 16px;color: #666;">
          <van-field v-model="minPrice" class="price-text" clearable placeholder="最低价" type="number" />&nbsp;_&nbsp;
          <van-field v-model="maxPrice" class="price-text" clearable placeholder="最高价" type="number" />
        </div>
        <div style="padding: 8px; text-align: center">
          <van-button round size="small" style="width: 40%; margin: 8px" type="info" @click="filterGoods">筛 选
          </van-button>
          <van-button plain round size="small" style="width: 40%; margin: 8px" type="info" @click="resetGoods">重 置
          </van-button>
        </div>
      </div>
    </van-popup>

    <div class="content-box flex-row row-between">
      <div class="item-box flex-row col-center" v-on:click="itemClicked(0)">
        <span style="color: #000000; font-size: 14px; margin-top: -3px">综合</span>
        <div style="margin-left: 4px;margin-top: 2px;">
          <van-icon v-if="clickedValue[0].sort === 1" name="ascending" />
          <van-icon v-else name="descending" />
        </div>
      </div>
      <div class="item-box flex-row col-center" v-on:click="itemClicked(1)">
        <span style="color: #000000; font-size: 14px; margin-top: -3px">销量</span>
        <div style="margin-left: 4px;margin-top: 2px;">
          <van-icon v-if="clickedValue[1].sort === 1" name="ascending" />
          <van-icon v-else name="descending" />
        </div>
      </div>
      <div class="item-box flex-row col-center" v-on:click="itemClicked(2)">
        <span style="color: #000000; font-size: 14px; margin-top: -3px">价格
        </span>
        <div style="margin-left: 4px;margin-top: 2px;">
          <van-icon v-if="clickedValue[2].sort === 1" name="ascending" />
          <van-icon v-else name="descending" />
        </div>
      </div>
      <div class="item-box flex-row col-center" v-on:click="itemClicked(3)">
        <span style="color: #000000; font-size: 14px; margin-top: -3px">筛选</span>
        <span class="iconfont icon-icon-6"></span>
      </div>
    </div>

    <van-list v-model="loading" :error.sync="error" :finished="finished" :finished-text="finishedText"
      error-text="请求失败，点击重新加载 A" @load="get_goods_list" style="background-color: #fff;">

      <div class="list">
        <div class="list-col">
          <div v-for="(goods, index) of goodsListByPromotion" :key="index">
            <div v-if="index % 2 === 0" class="list-item">
              <van-image
                :src="goods.headImage || 'https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/flf2dac3qmz9zw2ixui6enls.png'"
                fit="contain" radius="8px 8px 0 0" @click="go_goods_detail(goods)" />
              <div style="font-size: 15px;font-weight: 400;margin-top: 8px;padding: 8px;text-align: left"
                @click="go_goods_detail(goods)">
                <van-tag v-for="tag in goods.tags" :key="tag" color="#f55519"
                  style="font-size: 14px;padding: 0 4px;line-height: normal">{{ tag }}
                </van-tag>
                {{ goods.name }}
              </div>
              <div class="goods_price">
                <div class="price">
                  <img class="icon"
                    src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                  <span class="text" v-html="$options.filters.moneyFormatFilter(goods.price)"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="list-col">
          <div v-for="(goods, index) of goodsListByPromotion" :key="index">
            <div v-if="index % 2 !== 0" class="list-item">
              <van-image
                :src="goods.headImage || 'https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/flf2dac3qmz9zw2ixui6enls.png'"
                fit="contain" radius="8px 8px 0 0" @click="go_goods_detail(goods)" />
              <div style="font-size: 15px;font-weight: 400;margin-top: 8px;padding: 8px;text-align: left"
                @click="go_goods_detail(goods)">
                <van-tag v-for="tag in goods.tags" :key="tag" color="#f55519"
                  style="font-size: 14px;padding: 0 4px;line-height: normal">{{ tag }}
                </van-tag>
                {{ goods.name }}
              </div>
              <div class="goods_price">
                <div class="price">
                  <img class="icon"
                    src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
                  <span class="text" v-html="$options.filters.moneyFormatFilter(goods.price)"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </van-list>
  </div>
</template>

<script>
import GoodsUnit from "@/components/common/goods-unit";
import { api_get_brands_list_by_cate_id, api_get_goods_list_by_params } from "@/api/goods-api";

/**
 * 带排序功能界面的商品列表页面
 */
export default {
  name: "sort-table",

  components: { GoodsUnit },

  props: {
    /**
     * 商品类别编号
     */
    cateId: { type: Number, default: 0, required: true },

    /**
     * 列出指定 tag 的商品
     */
    tag: { type: String },

    /**
     * 商品列表排除指定的类别编号的商品
     */
    excludeCateIds: {},

    /**
     * 商品列表包含指定的类别编号的商品
     */
    includeCateIds: { type: String }
  },

  computed: {
    isChecked: function (brandId) {
      budo_log.info("#196 computed isChecked", brandId);
      return { color: "#f00" };
    },
  },

  data() {
    return {
      goodsListByPromotion: [], //促销商品
      sortStr: "", // 默认按后台指定顺序排
      pi: 0,
      brands: [],
      visibleFilterFlag: false,
      clickedValue: [],
      minPrice: "最低价",
      maxPrice: "最高价",
      brandIds: [],
      keyword: "",
      error: false,
      loading: false,
      finished: false,
      finishedText: "没有更多了 A"
    };
  },

  created() {
    for (let i = 0; i < 3; i++) {
      this.clickedValue[i] = { sort: 0 };
    }
  },

  methods: {
    go_goods_detail(goods) {
      this.$router.push({ path: 'goods-detail', query: { goodsId: goods.goodsId } })
    },

    itemClicked(e) {
      budo_log.info("#229 itemClicked", e, this.clickedValue);

      let sort = 0;
      if (e < 3) {
        sort = this.clickedValue[e].sort === 0 ? "ascend" : "descend";
        this.clickedValue[e].sort = this.clickedValue[e].sort === 0 ? 1 : 0;
      }

      if (e === 0) {
        this.sortStr = `g.goods_id.${sort}`;
      } else if (e === 1) {
        this.sortStr = `g.sale_count.${sort}`;
      } else if (e === 2) {
        this.sortStr = `g.price.${sort}`;
      } else if (e === 3) {
        this.visibleFilterFlag = !this.visibleFilterFlag;

        api_get_brands_list_by_cate_id(this.cateId).then((res) => {
          budo_log.info("#245 api_get_brands_list_by_cate_id", res)

          this.brands = res.data.records.map((b) => {
            b.active = false;
            return b;
          });
        });
      }

      this.goodsListByPromotion = [];
      this.pi = 0;
      this.get_goods_list();
    },

    search(val) {
      this.goodsListByPromotion = [];
      this.pi = 0;
      this.keyword = val;
      this.get_goods_list();
    },

    // van-list @load 触发
    get_goods_list() {
      this.finishedText = "加载中 A ...";

      this.pi++;

      budo_log.debug('#266 get_goods_list pi=', this.pi, "cateId=", this.cateId)

      let params = {
        pi: this.pi,
        keyword: this.keyword,
        sortStr: this.sortStr,
        excludeCateIds: this.excludeCateIds,
        includeCateIds: this.includeCateIds
      };

      if (this.cateId > 0) {
        params.cateId = this.cateId;
      }

      const maxPrice = parseInt(this.maxPrice, 10) * 100;
      const minPrice = parseInt(this.minPrice, 10) * 100;
      if (maxPrice && minPrice) {
        params.maxPrice = maxPrice;
        params.minPrice = minPrice;
      }

      if (this.brandIds.length > 0) {
        params.brandIds = this.brandIds.toString();
      }

      // 促销标签商品
      api_get_goods_list_by_params(params).then(res => {
        budo_log.debug('#295 api_get_goods_list_by_params', res)

        this.goodsListByPromotion = this.goodsListByPromotion.concat(res.data.records);

        if (this.goodsListByPromotion.length >= res.data.total) {
          this.finishedText = "没有更多了 _-_";
          this.finished = true;
        }

        if (res.data.total === 0) {
          this.finishedText = "看看其它的吧 -_-";
          this.finished = true;
        }

        this.loading = false;
      }).catch((error) => {
        budo_log.info("#264 error", error)
        this.loading = false;
        this.error = true;
      });
    },

    tagClick(e, brandId) {
      const brand = this.brands.find((b) => b.brandId === brandId);
      brand.active = !brand.active;
    },

    filterGoods() {
      this.sortStr = `g.price.ascend`;
      this.goodsListByPromotion = [];
      this.pi = 0;
      this.brandIds = this.brands.filter((b) => b.active === true).map((b) => b.brandId);
      this.get_goods_list();
    },

    resetGoods() {
      this.goodsListByPromotion = [];
      this.pi = 0;
      this.brandIds = [];
      this.maxPrice = '';
      this.minPrice = '';
      this.brands.filter((b) => b.active === true).map((b) => {
        b.active = false;
      });
      this.get_goods_list();
    }
  }
};
</script>

<style lang="scss" scoped>
.sort-table-page {
  padding: 0 12px;

  .content-box {
    margin-top: 8px;
    background-color: #ffffff;
    padding: 16px;
    border-radius: 5px;

    .item-box {
      color: #9d9d9d;

      .active-color {
        color: #ff492e;
      }
    }
  }
}

.goods-box {
  padding: 10px 0;

  .goods-item {
    width: 47%;
    background: #ffffff;
    border-radius: 4px;
    padding: 4px;
    margin-top: 4px;
  }
}

.filter {
  background-color: #ffffff;
  border-radius: 4px;
  padding: 20px;

  .price-text {
    border: solid 1px #ccc;
  }

  .title {
    font-size: 14px;
    font-weight: bold;
    margin-top: 8px;
    display: block;
    background-color: #f0f2f6;
    color: #0254c4;
    padding: 8px;
    border-radius: 5px;
  }

  .tag-active {
    font-size: 14px;
    background-color: #1e89f5;
    color: #fff;
    padding: 8px;
    border-radius: 5px;
    margin: 8px;
  }

  .tag {
    color: #333;
    background-color: #fff;
    font-size: 14px;
    margin: 8px;
    padding: 8px;
  }
}

.list {
  margin: 8px auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.list-col {
  display: flex;
  flex-direction: column;
  width: 50%;
  box-sizing: border-box;
}

.list-item {
  margin: 8px;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 1px rgba(234, 234, 234, 0.67);
}

.goods_price {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  line-height: 22px;

  .price {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-left: 8px;
    margin-bottom: 8px;
  }

  .icon {
    width: 16px;
    height: 16px;
    display: block;
    margin-top: 2px;
  }

  .cert {
    margin-right: 16px;
  }

  .text {
    font-size: 18px;
    font-weight: bold;
    color: #0090FF;
    margin-left: 2px;
  }
}
</style>
